import React, { createContext, useContext, useEffect, useState } from 'react';
import { apiFetch } from '../utils/apiFetch';

const PropertyContext = createContext(null);

export function PropertyProvider({ children }) {
  const [liveProps, setLiveProps] = useState({
    commercial: { price: 1500, yield: 7, label: 'Pre-leased Commercial Hub', id: '6911e2d435152a1bbfec7e31' },
    residential: { price: 500, yield: 5.5, label: 'Pre-leased Residential Tokens', id: '6911e2d435152a1bbfec7e32' },
  });

  useEffect(() => {
    apiFetch('/api/properties').then(data => {
      const props = Array.isArray(data) ? data : (data?.data || data?.properties || []);
      // Prefer the PRE-LEASED property; "Under-construction Commercial/Residential" also contain the word.
      const nameOf = p => (p.title || p.name || '').toLowerCase();
      const pick = (word) => props.find(p => nameOf(p).includes(word) && nameOf(p).includes('pre'))
        || props.find(p => nameOf(p).includes(word) && !nameOf(p).includes('under'))
        || props.find(p => nameOf(p).includes(word));
      const comm = pick('commercial');
      const resi = pick('residential');
      if (comm || resi) {
        setLiveProps({
          commercial: {
            price: parseFloat((comm?.currentNav || comm?.tokenPrice || 1500).toFixed(2)),
            yield: parseFloat((comm?.rentalYield || 7).toFixed(1)),
            label: comm?.title || comm?.name || 'Pre-leased Commercial Hub',
            id: comm?._id || '6911e2d435152a1bbfec7e31',
            navTarget: comm?.navTarget,
            navStartPrice: comm?.navStartPrice,
            navUpdateDays: comm?.navUpdateDays,
            navFloor: comm?.navFloor,
            navCeiling: comm?.navCeiling,
            lastTradePrice: comm?.lastTradePrice,
            lastTradeDate: comm?.lastTradeDate,
            annualReturn: comm?.annualReturn || 7,
          },
          residential: {
            price: parseFloat((resi?.currentNav || resi?.tokenPrice || 500).toFixed(2)),
            yield: parseFloat((resi?.rentalYield || 5.5).toFixed(1)),
            label: resi?.title || resi?.name || 'Pre-leased Residential Tokens',
            id: resi?._id || '6911e2d435152a1bbfec7e32',
            navTarget: resi?.navTarget,
            navStartPrice: resi?.navStartPrice,
            navUpdateDays: resi?.navUpdateDays,
            navFloor: resi?.navFloor,
            navCeiling: resi?.navCeiling,
            lastTradePrice: resi?.lastTradePrice,
            lastTradeDate: resi?.lastTradeDate,
            annualReturn: resi?.annualReturn || 8,
          },
        });
      }
    }).catch(() => {});
  }, []);

  return (
    <PropertyContext.Provider value={liveProps}>
      {children}
    </PropertyContext.Provider>
  );
}

export function useLiveProps() {
  return useContext(PropertyContext);
}
